import { createSlice } from '@reduxjs/toolkit';

export const isGuest = createSlice({
  name: 'isGuest',
  initialState: {
    data: false,
  },

  reducers: {
    setIsGuest: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setIsGuest } = isGuest.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.isLoading`
export const getIsGuest = (state) => {
  return state.isGuest.data;
};

export default isGuest.reducer;
